import SyncButton from './SyncButton';

export default SyncButton;
